module.exports = __webpack_public_path__ + "static/media/CrimsonGuard.745a8424.png";